import React from 'react';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

import { ChipV2, FieldRow, dsV2 } from '@bloomays-lib/ui.shared';
import type { ISociety } from '@bloomays-lib/types.shared';

export const SocietyFields = ({ society, kind }: { society?: ISociety | null; kind?: 'bloomer' | 'client' }) => {
  const { t } = useTranslation(['missionDashboard']);
  if (!society)
    return (
      <Box sx={{ fontSize: '12px', color: dsV2.color.t4, fontStyle: 'italic' }}>
        {t('society.notProvided', { ns: 'missionDashboard' })}
      </Box>
    );
  const showBank = kind === 'bloomer' && !society.portage;
  return (
    <>
      <FieldRow label={t('society.fields.name', { ns: 'missionDashboard' })} value={society.name} />
      <FieldRow
        label={t('society.fields.status', { ns: 'missionDashboard' })}
        value={
          society.status ? (
            <ChipV2
              label={`${society.status}${
                kind === 'bloomer' && society.portage ? t('society.portageSuffix', { ns: 'missionDashboard' }) : ''
              }`}
              tone="info"
              size="small"
            />
          ) : undefined
        }
      />
      <FieldRow label={t('society.fields.siret', { ns: 'missionDashboard' })} value={society.siret} />
      <FieldRow
        label={t('society.fields.tva', { ns: 'missionDashboard' })}
        value={society.tva || undefined}
        last={!showBank}
      />
      {showBank ? (
        <>
          <FieldRow label={t('society.fields.iban', { ns: 'missionDashboard' })} value={society.IBAN || undefined} />
          <FieldRow label={t('society.fields.bic', { ns: 'missionDashboard' })} value={society.BIC || undefined} last />
        </>
      ) : null}
    </>
  );
};
